import React from 'react';

export const moveScrollTo = (element, targetPosition) => {
    element.scrollTop = targetPosition;
};

export const animatedScrollTo = (element, targetPosition) => {
    const frameTime = 5;
    let scrollCount = 0;
    let scrollPos = 0;

    const startingPos = element.scrollTop;
    const totalDistance = targetPosition - startingPos;
    const duration = getScrollDuration(totalDistance);
    const scrollRadianStep = Math.PI / (duration / frameTime);

    const testInterv = setInterval(() => {
        const scale = 1 - (Math.cos(scrollCount * scrollRadianStep) + 1) / 2;
        scrollPos = startingPos + totalDistance * scale;
        element.scrollTop = scrollPos;

        scrollCount += 1;
        if (scrollRadianStep * scrollCount > Math.PI) {
            element.scrollTop = targetPosition; // Just in case it didn't go all the way due to decimals
            clearInterval(testInterv);
        }
    }, frameTime);
};

export const linearScrollTo = (element, targetPosition) => {
    const frameTime = 5;
    const totalDistance = targetPosition - element.scrollTop;
    const duration = getScrollDuration(totalDistance);
    const step = totalDistance / (duration / frameTime);
    const interv = setInterval(() => {
        element.scrollTop += step;
        if (element.scrollTop === targetPosition) {
            clearInterval(interv);
        }
    }, frameTime);
};

const getScrollDuration = (scrollDistance) => {
    return scrollDistance < 500 ? 150 : 500;
};

export const scrollAtBottom = (element) =>
    element.scrollTop + element.clientHeight >= element.scrollHeight;

export const scrollAtTop = (element) => element.scrollTop === 0;

/**
 * Returns an array with strings and every other string being bold
 */
export const makeBold = (text, indices = []) => {
    if (!text || indices.length === 0) return text;

    indices.sort((range1, range2) => range1[0] - range2[0]);
    indices = mergeOverlappingIndices(indices);
    const splitString = splitStringByRanges(text, indices);

    // Apply bold to every other string in the array
    const processedText = splitString.map((part, index) => {
        if (index % 2 === 0) {
            return part;
        } else {
            return (
                <mark
                    className={'bg-yellow/40 font-bold'}
                    key={'index-' + index}
                >
                    {part}
                </mark>
            );
        }
    });

    return processedText;
};

/**
 * Will cut the string where the ranges start and end.
 * Returns an array with the cut string parts.
 *
 * If the range starts at 0, the resulting array will start with an empty string at index 0.
 * Same goes for a range at the end of the string, with an empty string at the last index.
 */
export const splitStringByRanges = (text, indices = []) => {
    if (indices.length === 0) return [text];

    const result = [];
    let prevRange;

    indices.forEach((range) => {
        if (!prevRange) {
            result.push(text.slice(0, range[0]));
        } else {
            result.push(text.slice(prevRange[1] + 1, range[0]));
        }
        result.push(text.slice(range[0], range[1] + 1));
        prevRange = range;
    });
    result.push(text.slice(prevRange[1] + 1));

    return result;
};

/**
 * @param indices
 * Indices format should be an array with arrays in it.
 * Ex: [[2,4], [6,8]]
 */
export const mergeOverlappingIndices = (indices) => {
    const result = [];
    let last;

    indices.forEach((range) => {
        if (!last || range[0] > last[1]) {
            last = range;
            result.push(range);
        } else if (range[1] > last[1]) {
            last[1] = range[1];
        }
    });

    return result;
};
